import { toFixedWithoutRounding } from "@constants/common";
import { getVaultcraftData } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { numberToCurrency } from "utils";

const VAULT_ADDRESS = "0x11eAA7a46afE1023f47040691071e174125366C8";

const useVaultcraftData = () => {
  const { isLoading, data: response } = useQuery({
    queryKey: ["vaultcraft"],
    queryFn: async () => await getVaultcraftData(),
    refetchInterval: 60_000,
  });

  const vaultData = (response?.data || []).find(
    (vault: any) => vault.address === VAULT_ADDRESS
  );

  const tvl = vaultData?.tvl;
  const formattedTvl = tvl ? `${numberToCurrency(tvl.toFixed(2), 1)}` : "-";
  const apy = vaultData?.baseApy;
  const formattedApy = apy
    ? `${toFixedWithoutRounding(apy.toString(), 2)}%`
    : "-";

  return {
    isLoading,
    formattedTvl,
    formattedApy,
  };
};

export default useVaultcraftData;
